import { useVideoContext, useVideosComponentContext } from '../../../context';
import { useCamera } from '../useCamera';

import { useMediaRecorder } from './useMediaRecorder';

export function useVideoRecorderActions() {
	const { startMediaRecorder, stopMediaRecorder } = useMediaRecorder();
	const { openCamera, closeCamera } = useCamera();
	const {
		data: { stream, isRecording },
		actions: { setStream, setBlob, setIsRecording },
	} = useVideoContext();
	const {
		actions: { setUploadStep, setErrorMessage, setVideoSource },
	} = useVideosComponentContext();

	const prepareCamera = () => {
		setUploadStep('recorder');
		setBlob(null);
		void openCamera();
	};

	const startRecording = async () => {
		let mediaStream = stream;
		if (!mediaStream) {
			mediaStream = await openCamera();
		}
		if (!mediaStream) {
			return;
		}
		startMediaRecorder(mediaStream, {
			onstart: () => {
				setIsRecording(true);
				setErrorMessage('');
			},
			onstop: (blob) => {
				setIsRecording(false);
				setBlob(blob);
				closeCamera();
				setStream(null);
			},
		});
	};

	return {
		data: { isRecording, stream },
		actions: {
			startRecording,
			stopRecording: stopMediaRecorder,
			setBlob,
			prepareCamera,
			setUploadStep,
			setVideoSource,
		},
	};
}
